import { safeLs } from 'shared/storages';

const JWT_AUTH_KEY = 'jwt_auth';
export interface JwtAuthParams {
  access: string;
  refresh: string;
  verifier: string;
  state: string;
  returnUrl: string;
}
export const authStorage = {
  setJwtAuthParams(value: Partial<JwtAuthParams>): Promise<Partial<JwtAuthParams>> {
    return safeLs.add(JWT_AUTH_KEY, value);
  },
  getJwtAuthParams(): JwtAuthParams | undefined {
    return safeLs.get<JwtAuthParams, 'sync'>(JWT_AUTH_KEY, { parse: true, type: 'sync' });
  },
  cleanJwtAuthParams() {
    return safeLs.delete(JWT_AUTH_KEY, { returning: false });
  },
};
